import { useState } from "react";
import { Phone, MessageCircle } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { SITE } from "../lib/site";

const NUMBERS = [
  { display: SITE.phoneDisplay, tel: SITE.phoneTel, wa: SITE.whatsappMsg },
  { display: SITE.phone2Display, tel: SITE.phone2Tel, wa: SITE.whatsapp2Msg },
];

export const ContactMenu = ({
  type = "call",
  label,
  className = "",
  wrapperClassName = "",
  testid = "contact",
  up = false,
  fullWidth = false,
}) => {
  const [open, setOpen] = useState(false);
  const Icon = type === "call" ? Phone : MessageCircle;
  const accent = type === "call" ? "#ff3300" : "#25d366";

  return (
    <div className={`relative ${wrapperClassName}`}>
      <button
        data-testid={`${testid}-trigger`}
        onClick={() => setOpen((v) => !v)}
        className={className}
      >
        <Icon size={16} strokeWidth={2.2} />
        {label}
      </button>

      <AnimatePresence>
        {open && (
          <>
            <div
              className="fixed inset-0 z-40"
              onClick={() => setOpen(false)}
              aria-hidden="true"
            />
            <motion.div
              initial={{ opacity: 0, y: up ? 8 : -8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: up ? 8 : -8 }}
              transition={{ duration: 0.15 }}
              className={`absolute z-50 left-0 border border-[#232323] bg-[#0f0f0f] shadow-2xl ${
                up ? "bottom-full mb-2" : "top-full mt-2"
              } ${fullWidth ? "w-full" : "w-max min-w-full"}`}
            >
              <p className="border-b border-[#232323] px-4 py-2 font-mono text-[10px] uppercase tracking-[0.18em] text-[#8a8a8a]">
                {type === "call" ? "Scegli il numero" : "Scrivi su WhatsApp"}
              </p>
              {NUMBERS.map((n, i) => (
                <a
                  key={i}
                  href={type === "call" ? `tel:${n.tel}` : n.wa}
                  target={type === "call" ? undefined : "_blank"}
                  rel={type === "call" ? undefined : "noreferrer"}
                  data-testid={`${testid}-option-${i + 1}`}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-3 whitespace-nowrap px-4 py-3 font-mono text-sm text-[#f4f4f0] transition-colors duration-150 hover:bg-[#1a1a1a]"
                >
                  <Icon size={14} style={{ color: accent }} />
                  {n.display}
                </a>
              ))}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};
